import axios from 'axios';

export async function sendQuoteEmail(data) {
  try {
    const res = await axios.post('https://vasdomen.rs/send-quote-email.php', data, {
      headers: { 'Content-Type': 'application/json' }
    });
    return res.data;
  } catch (err) {
    console.error('sendQuoteEmail error', err);
    throw err;
  }
}
